const ResultsSection = () => (
  <section className="bg-[#2D1280] py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto text-center">
      <p className="text-[#A3E635] font-bold text-sm uppercase tracking-widest mb-3">Résultats réels</p>
      <h2 className="text-white font-black text-3xl lg:text-4xl mb-3 leading-tight">
        Grâce à cette Méthode,<br />
        Tu pourras aussi atteindre ces résultats
      </h2>
      <p className="text-white/50 text-sm mb-10 max-w-[500px] mx-auto">
        * Les performances passées ne préjugent pas des performances futures. Ces résultats sont des exemples réels de membres de la communauté LS INVEST.
      </p>
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
        {/* Big stat */}
        <div className="bg-[#1E0750] border border-[#A3E635]/20 rounded-2xl p-8 flex flex-col items-center">
          <div className="text-[#A3E635] font-black text-5xl mb-1">+ 12 345 €</div>
          <div className="text-white/60 text-sm">sur 12 mois (14,69 % / an)</div>
        </div>
        {/* Chart image */}
        <div className="w-full lg:w-[520px] h-[300px] rounded-2xl overflow-hidden border border-white/10">
          <img
            src="https://public.readdy.ai/ai/img_res/58819b6ffa159be1f5549bba94956948.jpg"
            alt="Résultats portefeuille"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </div>
  </section>
);

export default ResultsSection;
